import {
  CFA_ORDER_LIST,
  CFA_UPDATE_INVOICE,
  COMPANY_LIST,
  CURRENT_ORDER_LIST,
  ORDER_DETAIL,
  ORDER_HISTORY_LIST,
  ORDER_REMARKS_REASON_LIST,
  PROFILE_INFO,
  STOCK_RECONCILIATION_EXPORT,
  SUPPLY_ORDER_CFA,
  SUPPLY_ORDER_DETAIL,
  UPDATE_INVOICE,
  UPDATE_ORDER_STATUS,
  UPLOAD_INVOICE,
} from "./types";

export const getProfileInfo = (onSuccess, onError) => {
  return {
    type: PROFILE_INFO,
    onSuccess,
    onError,
  };
};
export const currentOrderList = (data, onSuccess, onError) => {
  return {
    type: CURRENT_ORDER_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const orderHistoryList = (data, onSuccess, onError) => {
  return {
    type: ORDER_HISTORY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const orderDetail = (id, onSuccess, onError) => {
  return {
    type: ORDER_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const updateOrderStatus = (data, onSuccess, onError) => {
  return {
    type: UPDATE_ORDER_STATUS,
    data,
    onSuccess,
    onError,
  };
};
export const supplyOrderCfa = (data, onSuccess, onError) => {
  return {
    type: SUPPLY_ORDER_CFA,
    data,
    onSuccess,
    onError,
  };
};

export const uploadInvoice = (file, onSuccess, onError) => {
  return {
    type: UPLOAD_INVOICE,
    file,
    onSuccess,
    onError,
  };
};

export const updateInvoiceAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_INVOICE,
    data,
    onSuccess,
    onError,
  };
};

export const companyListAction = (onSuccess, onError) => {
  return {
    type: COMPANY_LIST,
    onSuccess,
    onError,
  };
};

export const stockReconciliationExportAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_RECONCILIATION_EXPORT,
    data,
    onSuccess,
    onError,
  };
};

export const suppliedOrderCfaList = (data, onSuccess, onError) => {
  return {
    type: CFA_ORDER_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const supplyOrderDetail = (id, onSuccess, onError) => {
  return {
    type: SUPPLY_ORDER_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const CFAupdateInvoiceAction = (data, onSuccess, onError) => {
  return {
    type: CFA_UPDATE_INVOICE,
    data,
    onSuccess,
    onError,
  };
};
export const fetchOrderRemarksList = (onSuccess, onError) => {
  return {
    type: ORDER_REMARKS_REASON_LIST,
    onSuccess,
    onError,
  };
};
